import useRequest from '@/websdk/utils/request';

export default (function () {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/mqtt/hive_info',
    name: 'HIVE_INFO',
    method: 'GET'
  });
  // console.error('GET==>', JSON.stringify(data))
  return [isRequestSuccessed, data || [], exec];
})